// Contract with GTM: each name must exactly match a Custom Event trigger, else it no-ops in GA4
export const ANALYTICS_EVENTS = {
  ADD_COMMENT: 'add_comment',
  ADD_PAYMENT_INFO: 'add_payment_info',
  BOOK_AMENITY: 'book_amenity',
  CHANGE_PASSWORD: 'change_password',
  CLICK_GLOBAL_BANNER: 'click_global_banner',
  CLICK_RELEASE_NOTES: 'click_release_notes',
  CLICK_SUPPORT: 'click_support',
  COMPLETE_ONBOARDING: 'complete_onboarding',
  COMPLETE_TASK: 'complete_task',
  CREATE_AMENITY: 'create_amenity',
  CREATE_CALENDAR_EVENT: 'create_calendar_event',
  CREATE_CLASSIFIED: 'create_classified',
  CREATE_FAQ: 'create_faq',
  CREATE_FORM: 'create_form',
  CREATE_FORUM_POST: 'create_forum_post',
  CREATE_MAINTENANCE_INSPECTION: 'create_maintenance_inspection',
  CREATE_MAINTENANCE_ITEM: 'create_maintenance_item',
  CREATE_NEWS: 'create_news',
  CREATE_PARKING_RESERVATION: 'create_parking_reservation',
  CREATE_PROJECT: 'create_project',
  CREATE_REQUEST: 'create_request',
  CREATE_SURVEY: 'create_survey',
  CREATE_TASK: 'create_task',
  CREATE_UNIT_MESSAGE: 'create_unit_message',
  CREATE_USER: 'create_user',
  DELETE_ACCOUNT: 'delete_account',
  DISMISS_GLOBAL_BANNER: 'dismiss_global_banner',
  DOWNLOAD_ATTACHMENT: 'download_attachment',
  EXPORT_CONTENT: 'export_content',
  FORGOT_PASSWORD: 'forgot_password',
  INVITE_USER: 'invite_user',
  LOGIN: 'login',
  LOGIN_FAILURE: 'login_failure',
  LOGOUT: 'logout',
  PLAN_CHANGE: 'plan_change',
  PRINT_CONTENT: 'print_content',
  RESET_PASSWORD: 'reset_password',
  SEARCH_ASSOCIATION: 'search_association',
  SEND_SMS_BROADCAST: 'send_sms_broadcast',
  SEND_VOICE_BROADCAST: 'send_voice_broadcast',
  SHARE_CALENDAR_EVENT: 'share_calendar_event',
  SIGN_UP: 'sign_up',
  SUBMIT_FORM: 'submit_form',
  SUBMIT_SURVEY: 'submit_survey',
  UPLOAD_DOCUMENT: 'upload_document',
  USE_AI_FEATURE: 'use_ai_feature',
  USER_APPROVAL: 'user_approval',
  VIEW_AMENITY: 'view_amenity',
  VIEW_CALENDAR_EVENT: 'view_calendar_event',
  VIEW_CLASSIFIED: 'view_classified',
  VIEW_DOCUMENT: 'view_document',
  VIEW_FORM: 'view_form',
  VIEW_FORUM: 'view_forum',
  VIEW_MAIL_STATS: 'view_mail_stats',
  VIEW_MAINTENANCE_ITEM: 'view_maintenance_item',
  VIEW_NEWS: 'view_news',
  VIEW_PROJECT: 'view_project',
  VIEW_REPORT: 'view_report',
  VIEW_REQUEST: 'view_request',
  VIEW_SURVEY: 'view_survey',
  VIEW_TASK: 'view_task',
  VIEW_UNIT_MESSAGE: 'view_unit_message',
} as const;

export type TAnalyticsEvent = (typeof ANALYTICS_EVENTS)[keyof typeof ANALYTICS_EVENTS];
